import { render, staticRenderFns } from "./AlertDialog.vue?vue&type=template&id=3e22d72c&scoped=true&lang=pug&"
import script from "./AlertDialog.vue?vue&type=script&lang=js&"
export * from "./AlertDialog.vue?vue&type=script&lang=js&"
import style0 from "./AlertDialog.vue?vue&type=style&index=0&id=3e22d72c&prod&lang=scss&scoped=true&"
import style1 from "./AlertDialog.vue?vue&type=style&index=1&id=3e22d72c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e22d72c",
  null
  
)

export default component.exports